import _ from 'lodash';

export default (field, formatter, parser) => {
    return _.merge({}, field, {
        parser: parser,
        formatter: formatter
    });
};
